export enum EDrillDownTooltipValue {
    newAndCopy = 'newAndCopy'
}
